import { FC, useContext, useEffect, useState } from 'react';

import { MultiSelect, H3 } from '@smartshell/ui-kit';

import { SettingsLock } from 'components';
import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

import s from './DiscManager.module.scss';
import { DISC_LETTERS, getDiscLetters } from './utils';

export const DiscManager: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: {
      settings: { visibleDiscs },
    },
    actions: { setSetting },
  } = useContext(SettingsContext);

  const [discs, setDiscs] = useState<Array<number> | null>(null);
  const isAvailable = useIsFeatureAvailable('pc_disk_hide');
  useEffect(() => {
    setDiscs(getDiscLetters(visibleDiscs));
  }, [visibleDiscs]);

  return (
    <div className={s.container}>
      <div className={s.header}>
        <H3>{t('settings.shell.security.disk.title')}</H3>
        {!isAvailable && <SettingsLock />}
      </div>
      <span className={s.subtitle}>
        {t('settings.shell.security.disk.description')}
      </span>
      <div
        onBlur={() => {
          const discDigit = discs?.reduce((acc, disc) => acc + disc, 0) ?? 0;

          const value = `0x${discDigit.toString(16)}`;

          if (value === visibleDiscs) {
            return;
          }

          setSetting({
            alias: ESettingsAliases.SHELL_VISIBLE_DISCS,
            value,
          });
        }}
      >
        <MultiSelect
          variant="secondary"
          value={discs?.length ? discs : null}
          onChange={setDiscs}
          options={DISC_LETTERS}
          title={t('setting.security.discs.all')}
          bordered
          disabled={!isAvailable}
          className={!isAvailable ? s.multiselect_disabled : undefined}
        />
      </div>
    </div>
  );
};
